import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import OwnerProtectedRoute from "@/components/owner/OwnerProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import CaseVacanze from "@/pages/CaseVacanze";
import CityPage from "@/pages/CityPage";
import AttractionPage from "@/pages/AttractionPage";
import PropertyMiniSite from "@/pages/PropertyMiniSite";
import Proprietari from "@/pages/Proprietari";
import Prezzi from "@/pages/Prezzi";
import Faq from "@/pages/Faq";
import Contatti from "@/pages/Contatti";
import LegalPage from "@/pages/LegalPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import Properties from "@/pages/admin/Properties";
import PropertyWizard from "@/pages/admin/PropertyWizard";
import PropertyReviews from "@/pages/admin/PropertyReviews";
import Owners from "@/pages/admin/Owners";
import Contacts from "@/pages/admin/Contacts";
import Report from "@/pages/admin/Report";

import OwnerLogin from "@/pages/owner/OwnerLogin";
import OwnerDashboard from "@/pages/owner/OwnerDashboard";

export default function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/case-vacanze" element={<CaseVacanze />} />
          <Route path="/case-vacanze/:citySlug" element={<CityPage />} />
          <Route path="/case-vacanze-vicino-a/:attractionSlug" element={<AttractionPage />} />
          <Route path="/proprieta/:slug" element={<PropertyMiniSite />} />
          <Route path="/proprietari" element={<Proprietari />} />
          <Route path="/prezzi" element={<Prezzi />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy-policy" element={<LegalPage page="privacy-policy" />} />
          <Route path="/cookie-policy" element={<LegalPage page="cookie-policy" />} />
          <Route path="/termini-e-condizioni" element={<LegalPage page="termini-e-condizioni" />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin/properties" element={<ProtectedRoute><Properties /></ProtectedRoute>} />
          <Route path="/admin/properties/new" element={<ProtectedRoute><PropertyWizard /></ProtectedRoute>} />
          <Route path="/admin/properties/:id/edit" element={<ProtectedRoute><PropertyWizard /></ProtectedRoute>} />
          <Route path="/admin/properties/:id/reviews" element={<ProtectedRoute><PropertyReviews /></ProtectedRoute>} />
          <Route path="/admin/owners" element={<ProtectedRoute><Owners /></ProtectedRoute>} />
          <Route path="/admin/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
          <Route path="/admin/report" element={<ProtectedRoute><Report /></ProtectedRoute>} />

          <Route path="/owner/login" element={<OwnerLogin />} />
          <Route path="/owner" element={<OwnerProtectedRoute><OwnerDashboard /></OwnerProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}
